import { useMutation } from '@tanstack/react-query'

import { getUserCookieJwt } from '@src/api'
import { useAxios } from '@src/hooks/use-axios'

export const useGetUserCookieJwt = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: () => getUserCookieJwt(axiosInstance),
  })
}
